import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./Logo";
import { Button } from "./ui/button";
import { LogOut, Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export function TopBar() {
  const { user, team, logout } = useAuth();
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const copyCode = () => {
    if (!team?.join_code) return;
    navigator.clipboard.writeText(team.join_code);
    setCopied(true);
    toast.success("Team code copied");
    setTimeout(() => setCopied(false), 1500);
  };

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-40 bg-[#0d0d0d] border-b border-border">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-4">
        <button onClick={() => navigate("/")} data-testid="home-logo-button" className="shrink-0">
          <Logo size="sm" />
        </button>
        <div className="flex items-center gap-3">
          {team && (
            <button onClick={copyCode} data-testid="team-code-badge"
              className="hidden sm:flex items-center gap-2 h-9 px-3 rounded-md bg-card border border-border hover:border-secondary transition-colors">
              <span className="text-xs font-bold uppercase tracking-widest text-muted-foreground">{team.name}</span>
              <span className="font-heading font-bold tracking-widest text-secondary">{team.join_code}</span>
              {copied ? <Check className="h-3.5 w-3.5 text-secondary" /> : <Copy className="h-3.5 w-3.5 text-muted-foreground" />}
            </button>
          )}
          <div className="flex items-center gap-2">
            <div className="text-right hidden sm:block">
              <div className="text-sm font-bold leading-none">{user?.name}</div>
              <div className="text-[10px] uppercase tracking-widest text-primary font-bold">{user?.role}</div>
            </div>
            <Button onClick={doLogout} data-testid="logout-button" variant="ghost" size="icon"
              className="h-9 w-9 text-muted-foreground hover:text-primary">
              <LogOut className="h-5 w-5" strokeWidth={2.5} />
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
